import React from 'react';
import { Check } from '@phosphor-icons/react';
import type { ContactOption } from './options';
interface OptionCardProps {
  option: ContactOption;
  selected: boolean;
  onSelect: (id: string) => void;
}
export function OptionCard({
  option,
  selected,
  onSelect
}: OptionCardProps) {
  return <button type="button" role="radio" aria-checked={selected} onClick={() => onSelect(option.id)} className={['group flex w-full items-center gap-3 rounded-[var(--radius)] border px-4 py-3.5 text-left text-sm transition-all', 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--ring))] focus-visible:ring-offset-2', selected ? 'border-[hsl(var(--primary))] bg-[hsl(var(--primary))]/[0.04] shadow-sm' : 'border-[hsl(var(--border))] bg-[hsl(var(--card))] hover:border-[hsl(var(--foreground))]/20 hover:bg-[hsl(var(--muted))]/40'].join(' ')} data-id="element-73">
      <span aria-hidden="true" className={['flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full border transition-colors', selected ? 'border-[hsl(var(--primary))] bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))]' : 'border-[hsl(var(--border))] text-transparent group-hover:border-[hsl(var(--foreground))]/30'].join(' ')} data-id="element-74">
        <Check size={13} weight="bold" data-id="element-75" />
      </span>
      <span className={selected ? 'font-medium text-[hsl(var(--foreground))]' : 'text-[hsl(var(--foreground))]'} data-id="element-76">
        {option.label}
      </span>
    </button>;
}